import {
  Button,
  Col,
  Divider,
  Form,
  Row,
  Spin,
  Typography,
  Upload,
} from "antd";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import {
  Contract,
  ContractFile,
  ContractFileTable,
  get,
} from "../../../../api";
import { UploadFile } from "antd/lib";
import { basePath } from "../../../../api";
import { useParams } from "react-router-dom";

import { notification } from "antd";
import ApiResponse from "../../../../api/models/response";

type FilesFormProps = {
  type: string;
  row: ContractFileTable;
  file?: ContractFile;
  files?: ContractFile[];
  add: (v: any) => void;
  update: (v: any) => void;
  contract: Contract;
};

let keyToken = process.env.REACT_APP_LOCAL_STORAGE_TOKEN_KEY || "";

const FilesForm = (p: FilesFormProps) => {
  const { type, row, file, files, add, update, contract } = p;
  const { Text } = Typography;
  const [form] = Form.useForm();
  const fileList: UploadFile[] = [];
  const [fileBlob, setFileBlob] = useState<Blob | null>(null);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fileBlobs, setFileBlobs] = useState<Blob[]>([]);
  const [filesList, setFilesList] = useState<UploadFile[]>([]);

  if (file) {
    fileList.push({
      uid: file.id.toString(),
      name: file.name,
      status: "done",
      url: file.fileUrl,
    });
  }

  useEffect(() => {
    if (files) {
      setFilesList(
        files.map((f) => ({
          uid: f.id.toString(),
          name: f.name,
          status: "done",
          url: f.fileUrl,
        }))
      );
    }
  }, [files]);

  const addFileFunction = async (values: any) => {
    setLoading(true);
    try {
      if (!fileBlobs) return;

      const url = `${basePath}/contracts/${id}/files`;
      const formData = new FormData();

      if (row.key === "nomina_xml[]") {
        values.file.fileList.forEach((f: any) => {
          formData.append(`${row.key}`, f.originFileObj);
        });
        formData.append("file_id", String(0));
      } else {
        formData.append(row.key, values.file.file.originFileObj);
      }

      formData.append("customer_id", String(contract.customer_id));
      formData.append("supplier_id", String(contract.supplier_id));

      const isEdit = type === "edit";

      if (isEdit && file?.id && row.key !== "nomina_xml[]") {
        formData.append("file_id", String(file.id));
      }

      const fetchParams: RequestInit = {
        method: isEdit ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem(keyToken)}`,
        },
        body: formData,
      };

      const response = await fetch(url, fetchParams);
      const json = (await response.json()) as ApiResponse<any>;

      if (json.statusCode === 200) {
        notification.success({
          message: isEdit
            ? "Archivo editado correctamente"
            : "Archivo subido correctamente",
        });

        let savedFile;

        if (row.key === "nomina_xml[]") {
          savedFile = json.response.savedFiles;
        } else {
          savedFile = isEdit ? [json.response.file] : json.response.savedFiles;
        }

        if (json.response.message) {
          notification.warning({
            message: json.response.message,
          });
        }

        isEdit ? update(savedFile) : add(savedFile);
      } else {
        notification.warning({
          message: json.message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error al procesar el archivo",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <Form name="file" form={form} onFinish={addFileFunction}>
        <Divider />
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Col xs={20}>
            <Row style={{ marginBottom: 20 }}>
              <Col span={24} style={{ marginBottom: 10 }}>
                <Row align="middle" justify="space-between">
                  <Col>
                    <Text style={{ fontSize: 18, fontWeight: 500 }}>
                      {file?.name_description}
                      {file === undefined && row.name_description}
                    </Text>
                  </Col>

                  {file?.name_key !== "nomina_xml[]" &&
                    row?.key !== "nomina_xml[]" && (
                      <Col md={20}>
                        <Text style={{ fontSize: 16, fontWeight: 500 }}>
                          Un solo documento
                        </Text>
                      </Col>
                    )}
                </Row>
              </Col>

              <Col span={24} style={{ textAlign: "right" }}>
                <Form.Item name="file">
                  <Upload
                    multiple
                    maxCount={
                      file?.name_key !== "nomina_xml[]" &&
                      row?.key !== "nomina_xml[]"
                        ? 1
                        : 50
                    }
                    accept=".pdf,application/pdf,.sua,.xml,text/xml,application/xml"
                    fileList={filesList}
                    onChange={({ fileList }) => {
                      setFilesList(fileList);
                      setFileBlobs(
                        fileList.map((f) => f.originFileObj!).filter(Boolean)
                      );
                    }}
                    listType="picture-card"
                    customRequest={({ file, onSuccess }) => {
                      onSuccess?.("ok");
                      setFileBlobs((prev) => [...prev, file as Blob]);
                    }}
                  >
                    <button
                      style={{ border: 0, background: "none" }}
                      type="button"
                    >
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>Subir Archivo</div>
                    </button>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>

            <Row justify="end">
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="btn-add"
                  disabled={type === "watch" || loading}
                  loading={loading}
                >
                  Guardar
                </Button>
              </Form.Item>
            </Row>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default FilesForm;
